import { useContext, useLayoutEffect, useState } from 'react'
import { AppContext } from '../../contextApi/ContextApi';

export default function Logo({action}) {
  const { currentWebsite, fetchImage } = useContext(AppContext);
  const [domain] = useState(currentWebsite?.settings?.domain);
  const [logoUrl,setLogoUrl] = useState(null);

  useLayoutEffect(()=>{
    fetchImage(currentWebsite, currentWebsite?.settings?.logo, setLogoUrl);
  },[])

  return (
    <div id='navbarUpperDiv_right'>
      <img src={logoUrl} alt={`${domain.split(".")[0]}_logo`} className='navbarLogo' onClick={action}/>
    </div>
  )
}
